import * as angular from 'angular';

import { SelectorType } from '../../models/enum';
import { IRequestService } from '../../services';

export interface IshewhartService {
    getGetBetweenDates(guid: string, selectorType: SelectorType, beginDateTime: string, endDateTime: string): angular.IPromise<any[]>;
}

export class ShewhartService implements IshewhartService {
    static serviceId = 'shewhartService';

    static $inject = ['requestService'];

    constructor(
        private _requestService: IRequestService) {
    }

    getGetBetweenDates(guid: string, selectorType: SelectorType, beginDateTime: string, endDateTime: string): angular.IPromise<any[]> {
        let url = this._requestService.getUrlV1() + 'shewhart/';
        if (selectorType === SelectorType.identifier) {
            url = url + 'identifier/';
        }
        const params = {
            guid: guid,
            beginDateTime: beginDateTime,
            endDateTime: endDateTime
        };
        return this._requestService.get(url, params);
    }
}